var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-805.000000, -1285.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821.115626,1286.15404 C823.762884,1288.41773 823.369127,1292.10245 821.488268,1294.05546 L815.321852,1300.43587 C814.970289,1300.80007 814.502718,1301 814,1301 C813.500766,1301 813.029693,1300.79651 812.67813,1300.43232 L806.511714,1294.0519 C804.627353,1292.09885 804.240635,1288.41413 806.884356,1286.15404 C808.916414,1284.41522 812.055858,1284.67945 813.999991,1286.68961 C815.944124,1284.67945 819.083568,1284.41881 821.115626,1286.15404 Z M820.285918,1292.84865 C821.558581,1291.53117 821.825755,1289.00326 820.029285,1287.46441 C818.668732,1286.30045 816.559358,1286.46823 815.230459,1287.84286 L813.999991,1289.11752 L812.769523,1287.84286 C811.447662,1286.47538 809.338288,1286.30045 807.970697,1287.46796 C806.170691,1289.00685 806.430861,1291.52043 807.714064,1292.84865 L813.880446,1299.22907 C813.964835,1299.31477 814.035147,1299.31477 814.119536,1299.22907 L820.285918,1292.84865 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4e49e31a.svg";
export { ForwardRef as ReactComponent };